import React from 'react';
import divider from '../../images/svg/divider.svg';
import { useFlags } from 'launchdarkly-react-client-sdk';

var Separator = function Separator(props) {
  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;
  var _props$topPadding = props.topPadding,
      topPadding = _props$topPadding === void 0 ? "medium" : _props$topPadding,
      _props$bottomPadding = props.bottomPadding,
      bottomPadding = _props$bottomPadding === void 0 ? "medium" : _props$bottomPadding,
      _props$image = props.image,
      image = _props$image === void 0 ? '1' : _props$image,
      display = props.display,
      background = props.background;

  var Barrel = function Barrel(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? "#2B1D10" : _ref$color,
        _ref$background = _ref.background,
        background = _ref$background === void 0 ? "#FFFFFF" : _ref$background;
    return /*#__PURE__*/React.createElement("svg", {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0_2110_12651)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M30.8964 35.1702L38.4364 34.2282L38.9664 32.3222C40.3004 27.5242 40.3644 22.4602 39.1564 17.6282L38.1964 13.7902L30.8944 12.8782C26.3184 12.3062 21.6784 12.3062 17.1024 12.8782L9.80039 13.7902L8.84039 17.6282C7.63239 22.4602 7.69839 27.5222 9.03039 32.3222L9.56039 34.2282L17.1004 35.1702C21.6764 35.7422 26.3164 35.7422 30.8924 35.1702H30.8964Z",
      fill: color
    }), /*#__PURE__*/React.createElement("path", {
      d: "M31.3928 8.90797L37.1568 9.62797L36.2548 6.01597C36.1008 5.39797 35.5948 4.92997 34.9648 4.82597L33.4688 4.57597C27.1988 3.53197 20.7988 3.53197 14.5308 4.57597L13.0348 4.82597C12.4068 4.92997 11.9008 5.39797 11.7448 6.01597L10.8428 9.62797L16.6068 8.90797C21.5128 8.29397 26.4868 8.29397 31.3908 8.90797H31.3928Z",
      fill: color
    }), /*#__PURE__*/React.createElement("path", {
      d: "M24.0006 39.6003C21.5306 39.6003 19.0606 39.4463 16.6086 39.1403L10.7246 38.4043L11.7326 42.0343C11.8966 42.6263 12.3846 43.0703 12.9886 43.1803L13.4926 43.2723C19.7886 44.4163 26.2306 44.5043 32.5546 43.5323L34.9806 43.1583C35.6026 43.0623 36.1106 42.6123 36.2786 42.0043L37.2786 38.4043L31.3946 39.1403C28.9426 39.4463 26.4726 39.6003 24.0026 39.6003H24.0006Z",
      fill: color
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0_2110_12651"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "48",
      height: "48",
      fill: background
    }))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "\n    cb-separator\n    ".concat("cb-l-padding-".concat(topPadding, "--top"), "\n    ", "cb-l-padding-".concat(bottomPadding, "--bottom"), "\n    ", image === '0' ? "cb-separator--image" : '', "\n    ").concat(typeof display !== 'undefined' ? "cb-separator--".concat(display) : '', "\n    ").concat(typeof display !== 'undefined' ? "cb-separator__bg--".concat(background) : '', "\n    ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container cb-l-padding--none"
  }, typeof display !== 'undefined' && display === 'solid' ? /*#__PURE__*/React.createElement("hr", null) : useNewRebrandStyles ? /*#__PURE__*/React.createElement("div", {
    className: "cb-separator__barrel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-separator__barrel__line"
  }), /*#__PURE__*/React.createElement(Barrel, {
    color: background === 'solid' ? '#FFFFFF' : '#2B1D10',
    background: background === 'solid' ? '#2B1D10' : '#FFFFFF'
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-separator__barrel__line"
  })) : /*#__PURE__*/React.createElement("img", {
    src: divider
  })));
};

export default Separator;